
import React from "react"
import { useNavigate } from 'react-router-dom'
import hotelcss from './css/hotelhotellist.module.css';
import { useEffect } from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { setErrorMessage } from "../tools/errorhandling";
import Dropdown from 'react-multilevel-dropdown';
import { MdEdit, MdDelete } from "react-icons/md";
import {
    getmyweekschedule
} from "../dbconnector/connector";
import moment from 'moment';
//import HolidayRequestNode from '../customNodes/HolidayRequestNode';

const Weekschedule = (props) => {
    const t = props.translation
    const [user, setUser] = useState({});
    const [days, setdays] = useState({
        "0": "zondag",
        "1": "maandag",
        "2": "dinsdag",
        "3": "woensdag",
        "4": "donderdag",
        "5": "vrijdag",
        "6": "zaterdag",
    })
    const [weekschedule, setWeekschedule] = useState({});
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)
    var mobile = require('is-mobile');

    useEffect(() => {
        setUser({});
        setUser(props.user)
        if (props.user) {
            LoadSchedule()
        }
    }, [props]);

    useEffect(() => {

        // LoadSchedule();
        try {
            if (document.getElementById("IconCleaning") !== null)
                document.getElementById("IconCleaning").style.display = "none";
            if (document.getElementById("IconMyData") !== null)
                document.getElementById("IconMyData").style.display = "none";
            if (document.getElementById("IconMyHoliday") !== null)
                document.getElementById("IconMyHoliday").style.display = "none";
            if (document.getElementById("IconMyContract") !== null)
                document.getElementById("IconMyContract").style.display = "none";
        } catch (e) {
            setErrorMessage("Error while retrieving user data")
        }
    }, []);

    const handleCancel = () => {
        document.getElementById("assignmentdetails").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }


    const LoadSchedule = () => {

        ////console.log("myid", props.user)
        ////console.log("weekschedule", weekschedule)
        if (props.user !== undefined && props.user !== null) {
            ////console.log("myidddddddddd", props.user.id)
            setWeekschedule([]);//props.user.id
            getmyweekschedule(props.user.id).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        //console.log("body", body.myrooster[0])
                        buildschedule(body.myschedule[0], body.myrooster)
                        //setWeekschedule(body[0])
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
            buildschedule()
        }
    }
    const buildschedule = (schedule, rooster) => {

        if (schedule) {
            // //console.log("verlof1", schedule["verlof1"])
            if (document.getElementById("maandag") !== null) {
                if (schedule.maandag === 1) {
                    document.getElementById("maandag").innerText = t("vrijedag")
                } else {
                    document.getElementById("maandag").innerText = schedule.starttime + " - " + schedule.endtime
                }
                if (schedule.dinsdag === 1)
                    document.getElementById("dinsdag").innerText = t("vrijedag")
                else
                    document.getElementById("dinsdag").innerText = schedule.starttime + " - " + schedule.endtime

                if (schedule.woensdag === 1)
                    document.getElementById("woensdag").innerText = t("vrijedag")
                else
                    document.getElementById("woensdag").innerText = schedule.starttime + " - " + schedule.endtime
                if (schedule.donderdag === 1)
                    document.getElementById("donderdag").innerText = t("vrijedag")
                else
                    document.getElementById("donderdag").innerText = schedule.starttime + " - " + schedule.endtime
                if (schedule.vrijdag === 1)
                    document.getElementById("vrijdag").innerText = t("vrijedag")
                else
                    document.getElementById("vrijdag").innerText = schedule.starttime + " - " + schedule.endtime
                if (schedule.zaterdag === 1)
                    document.getElementById("zaterdag").innerText = t("vrijedag")
                else
                    document.getElementById("zaterdag").innerText = schedule.starttime + " - " + schedule.endtime
                if (schedule.zondag === 1)
                    document.getElementById("zondag").innerText = t("vrijedag")
                else
                    document.getElementById("zondag").innerText = schedule.starttime + " - " + schedule.endtime
            }
            if (schedule["verlof1"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(0).getDay()]).innerText = t("holiday")
            }
            if (schedule["verlof2"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(1).getDay()]).innerText = t("holiday")
            }
            if (schedule["verlof3"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(2).getDay()]).innerText = t("holiday")
            }
            if (schedule["verlof4"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(3).getDay()]).innerText = t("holiday")
            }
            if (schedule["verlof5"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(4).getDay()]).innerText = t("holiday")
            }
            if (schedule["verlof6"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(5).getDay()]).innerText = t("holiday")
            }
            if (schedule["verlof7"] == 1) {
                document.getElementById(days[AddDaysToCurrentDate(6).getDay()]).innerText = t("holiday")
            }
        }
        // if (rooster) {
        //     rooster.forEach(dayrooster => {
        //         document.getElementById(days[new Date(dayrooster.roosterdag).getDay()]).innerHTML = ""
        //     })
        //     rooster.forEach(dayrooster => {
        //         const hotel = document.createElement("div")
        //         hotel.id = dayrooster.VM_Beginuur
        //         hotel.className = "weekschedule"
        //         hotel.innerHTML = dayrooster.VM_Beginuur + t("at") + "<b>" + dayrooster.hotelname + "</b></br>"
        //         document.getElementById(days[new Date(dayrooster.roosterdag).getDay()]).appendChild(hotel)
        //     })
        //     const labelmessage = document.createElement("div")
        //     labelmessage.className = "weekschedule footnote"
        //     labelmessage.innerText = t("footnote")
        //     document.getElementById(days[AddDaysToCurrentDate(1).getDay()]).appendChild(labelmessage)
        // }
    }

    function AddDaysToCurrentDate(daystoadd) {
        // 1. Create a new Date instance
        const date = new Date();
        // 2. Add 1 day to the current date
        date.setDate(date.getDate() + daystoadd);
        // 3. Format it (optional, toLocaleDateString formats to local standards like BE)
        return date//.getDay();
    };

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'>
                    </div>
                    <div className="checkinTime">
                        <div id="timelabel" >
                        </div>
                        <div id="time">
                        </div>
                    </div>
                </header>
                <div id="coverAll" className="coverall">

                </div>
                <div id="filters" className="form" >
                    <label className='formtitleContentBox'>
                        {t("MyWeekschedule")}
                    </label>
                    <br></br>
                    <div className="contentbox">
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {/* {t("day" + AddDaysToCurrentDate(0).getDay())}: */}
                                {AddDaysToCurrentDate(0).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(0).getDay()]}>
                            </div>
                        </div>
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {/* {t("day" + AddDaysToCurrentDate(1).getDay())}: */}
                                {AddDaysToCurrentDate(1).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(1).getDay()]}>
                            </div>
                        </div>
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {AddDaysToCurrentDate(2).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(2).getDay()]}>

                            </div>
                        </div>
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {/* {t("day" + AddDaysToCurrentDate(3).getDay())}: */}
                                {AddDaysToCurrentDate(3).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(3).getDay()]}>
                                {/* {weekschedule.starttime} - {weekschedule.endtime} */}
                            </div>
                        </div>
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {/* {t("day" + AddDaysToCurrentDate(4).getDay())}: */}
                                {AddDaysToCurrentDate(4).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(4).getDay()]}>
                                {/* {weekschedule.starttime} - {weekschedule.endtime} */}
                            </div>
                        </div>
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {/* {t("day" + AddDaysToCurrentDate(5).getDay())}: */}
                                {AddDaysToCurrentDate(5).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(5).getDay()]}>
                                {/* {weekschedule.starttime} - {weekschedule.endtime} */}
                            </div>
                        </div>
                        <div id="searchbox" className="formElementWeekSchedule">
                            <label className='labelcolor'>
                                {/* {t("day" + AddDaysToCurrentDate(6).getDay())}: */}
                                {AddDaysToCurrentDate(6).toLocaleDateString("nl-BE")}:
                            </label>
                            <div className='weekschedule' id={days[AddDaysToCurrentDate(6).getDay()]}>
                                {/* {weekschedule.starttime} - {weekschedule.endtime} */}
                            </div>
                        </div>
                    </div>

                    <div>

                    </div>
                </div>
            </div>
        </>
    )

}

export default Weekschedule